import { Component } from '@angular/core';

@Component({
  selector: 'app-table-panel',
  templateUrl: './table-panel.component.html',
  styleUrls: ['./table-panel.component.scss'],
  standalone: false
})
export class TablePanelComponent {
}
